// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-v2-edit-name .fi-task-v2-edit-attachemnts-wrapper {
  margin-top: 16px;
}
.fi-task-v2-edit-name .mat-divider {
  margin-bottom: 16px;
  border-top-color: #f1f0f4;
}
.fi-task-v2-edit-name .fi-attachments-list.new-layout {
  gap: 10px;
  margin: 0;
}
.fi-task-v2-edit-name .fi-attachments-list.new-layout .fi-attachments-list-item {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/task-v2/fi-task-v2-edit/fi-task-v2-edit-name/fi-task-v2-edit-name.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAEI;EACI,mBAAA;EACA,yBAAA;AAAR;AAEI;EACI,SAAA;EACA,SAAA;AAAR;AACQ;EACI,SAAA;AACZ","sourcesContent":[".fi-task-v2-edit-name {\r\n    .fi-task-v2-edit-attachemnts-wrapper {\r\n        margin-top: 16px;\r\n    }\r\n    .mat-divider {\r\n        margin-bottom: 16px;\r\n        border-top-color: #f1f0f4;\r\n    }\r\n    .fi-attachments-list.new-layout {\r\n        gap: 10px;\r\n        margin: 0;\r\n        .fi-attachments-list-item {\r\n            margin: 0;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
